export default "__VITE_ASSET__DTjy$zJ2__"